import React from "react";
import { CtaButton } from "./CtaButton";
type SectionCtaProps = {
  heading: string;
  label: string;
  note?: string;
  dark?: boolean;
};
export function SectionCta({
  heading,
  label,
  note = "$27 USD · One-time payment · Digital product",
  dark = false
}: SectionCtaProps) {
  return <div className="mx-auto mt-12 w-full max-w-xl text-center" data-id="element-85" data-mp="3nc9vg8n2089d">
      <p className={`font-display text-xl font-black uppercase leading-tight sm:text-2xl ${dark ? "text-white" : "text-ink"}`} data-id="element-86" data-mp="3nemhoxzuh4s8">{heading}</p>
      <div className="mt-5" data-id="element-87" data-mp="3devqb56kz5wd">
        <CtaButton label={label} data-id="element-88" data-mp="3df5f4pfw370h" />
      </div>
      <p className={`mt-3 text-sm font-medium ${dark ? "text-white/75" : "text-muted"}`} data-id="element-89" data-mp="2zmxn1azjw484">{note}</p>
    </div>;
}